import { _normalize, collectionCommand } from 'volta/utils/api';

import Task, { TaskCommands } from './task';
import type {
  ICreateTaskCmd,
  IDeleteTaskCmd,
  IReopenTaskCmd,
  IResolveTaskCmd,
  IUpdateTaskCmd
} from './types/tasks';
import { Type } from '@warp-drive/core-types/symbols';

interface ILinkedEntityPayload {
  simulationId: string;
  scenarioId: string;
  skuId: string;
}

export default class SimulationItemSettingTask extends Task<
  Record<string, any>,
  ILinkedEntityPayload
> {
  /**
   * Commands
   */

  static createTask = collectionCommand<
    ICreateTaskCmd,
    SimulationItemSettingTask,
    typeof SimulationItemSettingTask
  >(TaskCommands.CreateTask, {
    ajaxOptions: { queryParams: { include: 'createdBy,resolvedBy,assignees' } }
  });

  static updateTask = collectionCommand<
    IUpdateTaskCmd,
    SimulationItemSettingTask,
    typeof SimulationItemSettingTask
  >(TaskCommands.UpdateTask);

  static deleteTask = collectionCommand<IDeleteTaskCmd, void, typeof SimulationItemSettingTask>(
    TaskCommands.DeleteTask
  );

  static resolveTask = collectionCommand<
    IResolveTaskCmd,
    SimulationItemSettingTask,
    typeof SimulationItemSettingTask
  >(TaskCommands.ResolveTask);

  static reopenTask = collectionCommand<
    IReopenTaskCmd,
    SimulationItemSettingTask,
    typeof SimulationItemSettingTask
  >(TaskCommands.ReopenTask);

  // @ts-ignore
  [Type] = 'simulation-item-setting-task' as const;
}
